// src/extenders/klaviyo-back-in-stock.js
var KlaviyoBackInStock = class extends HTMLElement {
  constructor() {
    var _a;
    super();
    const backInStockElement = this;
    const sectionId = backInStockElement.getAttribute("data-section-id");
    const variantId = (_a = document.querySelector(`#ProductVariantId-${sectionId}`)) == null ? void 0 : _a.value;
    const backInStockFormElement = backInStockElement.querySelector("form");
    const formOverlaySuccess = backInStockElement.querySelector(".form-overlay--success");
    const formOverlayError = backInStockElement.querySelector(".form-overlay--error");
    const sendSubscribeRequest = async (emailAddress) => {
      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: `${emailAddress}`
                }
              }
            },
            channels: ["EMAIL"]
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      };
      try {
        const date = /* @__PURE__ */ new Date();
        let currentDay = String(date.getDate()).padStart(2, "0");
        let currentMonth = String(date.getMonth() + 1).padStart(2, "0");
        let currentYear = date.getFullYear();
        let currentDate = `${currentYear}-${currentMonth}-${currentDay}`;
        const response = await fetch(
          "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Umbs9D",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Revision": "2024-06-15"
            },
            body: JSON.stringify(payload)
          }
        );
        if (response.status === 202) {
          formOverlaySuccess.setAttribute("aria-hidden", "false");
          setTimeout(() => {
            formOverlaySuccess.setAttribute("aria-hidden", "true");
          }, 5e3);
        } else {
          formOverlayError.setAttribute("aria-hidden", "false");
          setTimeout(() => {
            formOverlayError.setAttribute("aria-hidden", "true");
          }, 5e3);
        }
      } catch (error) {
        console.log(error);
        formOverlayError.setAttribute("aria-hidden", "false");
        setTimeout(() => {
          formOverlayError.setAttribute("aria-hidden", "true");
        }, 5e3);
      }
    };
    backInStockFormElement.addEventListener("submit", (event) => {
      event.preventDefault();
      const emailAddress = backInStockFormElement.querySelector('input[type="email"]');
      if (emailAddress.validity.valid === true) {
        sendSubscribeRequest(emailAddress.value);
      }
    });
  }
};
if (customElements.get("klaviyo-back-in-stock") === void 0) {
  customElements.define("klaviyo-back-in-stock", KlaviyoBackInStock);
}
